import { DEPLOYMENT_CONFIG } from '../config/deployment';

// API Configuration Utility
// Get API base URL dynamically on each request to ensure correct hostname detection
const getApiBaseUrl = () => {
  return DEPLOYMENT_CONFIG.getApiBaseUrl();
};

// Helper function to build full API URLs
// This is called dynamically to ensure we get the correct API URL based on current hostname
export const buildApiUrl = (endpoint) => {
  const API_BASE_URL = getApiBaseUrl(); // Get fresh API URL on each call
  // Remove leading slash if present to avoid double slashes
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  const fullUrl = `${API_BASE_URL}/${cleanEndpoint}`;
  
  // Debug logging - always show to help diagnose API URL issues
  console.log('[API Request]', {
    hostname: window.location.hostname,
    endpoint,
    apiBaseUrl: API_BASE_URL,
    fullUrl
  });
  
  return fullUrl;
};

// Helper function to make authenticated API requests
export const apiRequest = async (endpoint, options = {}) => {
  const token = localStorage.getItem('token');
  
  const defaultHeaders = {
    'Content-Type': 'application/json',
    ...(token && { 'Authorization': `Bearer ${token}` }),
    ...options.headers
  };

  const config = {
    ...options,
    headers: defaultHeaders
  };

  const url = buildApiUrl(endpoint);
  
  try {
    const response = await fetch(url, config);
    const data = await response.json();
    
    return {
      ok: response.ok,
      status: response.status,
      data,
      headers: response.headers
    };
  } catch (error) {
    console.error('API request failed:', error);
    throw error;
  }
};

// Common API methods
export const api = {
  get: (endpoint) => apiRequest(endpoint, { method: 'GET' }),
  post: (endpoint, body) => apiRequest(endpoint, { 
    method: 'POST', 
    body: JSON.stringify(body) 
  }),
  put: (endpoint, body) => apiRequest(endpoint, { 
    method: 'PUT', 
    body: JSON.stringify(body) 
  }),
  delete: (endpoint) => apiRequest(endpoint, { method: 'DELETE' })
};

export default api;
